// App.jsx
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
import Home from "./Views/Home";
import Services from "./Views/Services";
import ServiceDetail from "./Views/ServiceDetail";
import Contact from "./Views/Contact";
import Careers from "./Views/Careers";
import About from "./Views/About";
import { servicesData } from "./data/servicesData"; // Import the services data
import Portfolio from "./Views/Portfolio";
import JobDetail from "./Views/JobDetail";
import jobsData from "./Views/jobsData";

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="bg-black text-white selection:bg-cyan-500 selection:text-white">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/careers/:jobSlug" element={<JobDetail />} />

          {/* Individual Service Routes */}
          {Object.keys(servicesData).map((serviceId) => (
            <Route
              key={serviceId}
              path={`/services/${serviceId}`}
              element={<ServiceDetail serviceId={serviceId} />}
            />
          ))}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
